import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router";
import DEVELOPMENT_CONFIG from "../../helper/config";
import { NotificationManager } from "src/util/notify";
import { useDispatch } from "react-redux";
import ErrorHelper from "../../helper/error-helper";
import "../../custom-css/custom-style.css";
import Loader from "../../control-components/loader/loader";
import APP_ROUTES from "../../helper/app-routes";
import InputKendoRct from "../../control-components/input/input";
import { AuthService } from "../../services/authService";

function ConfirmOTP() {
  const navigate = useNavigate();
  const [errors, setErrors] = useState("");
  const [loading, setLoading] = useState(false);
  const [settingError, setSettingError] = useState(false);
  const { state } = useLocation();
  const [otp, setOTP] = useState("");

  const handleSubmit = (event) => {
    setSettingError(true);
    if (handleValidation()) {
      event.preventDefault();
      confirmOTP();
    }
  };

  const confirmOTP = async () => {
    setLoading(true);

    let newFields = state?.fields;

    await AuthService.confirmOTP(newFields, otp)
      .then((result) => {
        setLoading(false);
        NotificationManager.success("Otp verified successfully");
        localStorage.setItem(DEVELOPMENT_CONFIG.TOKEN, result.resultData.token);
        localStorage.setItem(
          "adminDetail",
          JSON.stringify(result.resultData.userInfo)
        );
        navigate(APP_ROUTES.DASHBOARD);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (!otp || otp.trim().length === 0) {
      formIsValid = false;
      errors["otp"] = ErrorHelper.OTP_BLANK;
    }
    setErrors(errors);
    return formIsValid;
  };
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setOTP(value);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="login-form">
        <div className="container-fluid">
          <div className="row example-wrapper">
            <div className="col-md-8 col-xl-5  col-lg-6 mx-auto">
              <h1>notenetic</h1>

              <div className="inner-login-notenetic">
                <h2 class="otp-heading"> OTP Confirmation</h2>

                <div className="Service-accept edit-Service-popup">
                  <div className="row">
                    <div className="mb-2 col-md-6 col-12 w-100 mb-0 pb-0 ">
                      <InputKendoRct
                        name="otp"
                        value={otp}
                        onChange={handleChange}
                        label="Confirm Otp"
                        error={otp == "" && errors.otp}
                        validityStyles={settingError}
                        required={true}
                        type="text"
                        className={"mt-3"}
                      />
                    </div>
                  </div>
                </div>

                <button type="submit" onClick={handleSubmit}>
                  Confirm OTP
                </button>
                {loading == true && <Loader />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
export default ConfirmOTP;
